export default ['saveLR', 'getData', 'setData', 'isEditable', 'showIframePopup', 'showVideoPopup'];
